const summarizePluginDatePattern = /^(\d{4})\W(\d{1,2})\W(\d{1,2})/;

export function sanitizeDateFromSummarizePlugin(dateString: string): string {
  const match = dateString.match(summarizePluginDatePattern);
  if (match) {
    const [, year, month, day] = match;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  throw new Error(`Could not parse date string: ${dateString}`);
}
